export const COIN = {
    USD_DOLLAR: 'USD',
    SLP_COIN: 'SLP',
    AXS_COIN: 'AXS',
};

export const TREE_DEPTH = {
    AXIE: 1,
    AXIE_WITH_CHILDREN: 2,
};

export const AXIE_AGE = {
    EGG: 1,
    ADULT: 4,
};

export const AXIE_PARTS = ['eyes', 'ears', 'mouth', 'horn', 'back', 'tail'];
export const AXIE_CLASSES = ['Aquatic', 'Beast', 'Reptile', 'Bug', 'Plant', 'Bird', 'Mech', 'Dusk', 'Dawn'];
export const AXIE_PARTS_CLASSES = ['aquatic', 'beast', 'reptile', 'bug', 'plant', 'bird'];
export const GENES_TYPES = ['d', 'r1', 'r2'];
